var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.7094 0.956177H10.1049C4.74759 0.956177 0.410156 5.29361 0.410156 10.651V39.2614C0.410156 44.6127 4.74759 48.9502 10.1049 48.9502H38.7154C44.0667 48.9502 48.4102 44.6127 48.4102 39.2554V10.651C48.4042 5.29361 44.0667 0.956177 38.7094 0.956177Z",
    fill: "url(#paint0_linear_3784_109)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2029 11.9828L25.1748 10.303C25.7747 9.2531 27.1126 8.8992 28.1625 9.4991C29.2124 10.099 29.5663 11.4368 28.9664 12.4867L19.6015 28.6968H26.3746C28.5704 28.6968 29.8002 31.2765 28.8464 33.0642H8.98889C7.77708 33.0642 6.80518 32.0923 6.80518 30.8805C6.80518 29.6687 7.77708 28.6968 8.98889 28.6968H14.5562L21.6834 16.3443L19.4577 12.4807C18.8578 11.4308 19.2117 10.105 20.2616 9.4931C21.3115 8.8932 22.6373 9.2471 23.2492 10.297L24.2029 11.9828Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.78 35.314L13.6803 38.9555C13.0804 40.0054 11.7425 40.3593 10.6926 39.7594C9.64273 39.1595 9.28883 37.8217 9.88873 36.7718L11.4485 34.0722C13.2123 33.5263 14.6461 33.9462 15.78 35.314Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8617 28.7088H39.543C40.7548 28.7088 41.7267 29.6807 41.7267 30.8925C41.7267 32.1043 40.7548 33.0762 39.543 33.0762H36.3874L38.5171 36.7718C39.117 37.8217 38.7631 39.1475 37.7132 39.7594C36.6633 40.3593 35.3374 40.0054 34.7255 38.9555C31.138 32.7342 28.4443 28.0789 26.6566 24.9773C24.8268 21.8216 26.1347 18.654 27.4245 17.5802C28.8584 20.0399 31.0001 23.7534 33.8617 28.7088Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3784_109",
    x1: 24.4102,
    y1: 0.956177,
    x2: 24.4102,
    y2: 48.9502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0073F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1);
export default __webpack_public_path__ + "static/media/Group (1).92ecc930fad248ed99057a522cf31355.svg";
export { ForwardRef as ReactComponent };